import type { ContractContext } from './context';
import type { ContractError } from './errors';
import type { EventId } from './ids';

export type ConfigEventType =
  | 'player.ready'
  | 'scene.loaded'
  | 'configuration.initialized'
  | 'configuration.changed'
  | 'configuration.validated'
  | 'interaction.intent'
  | 'hotspot.clicked'
  | 'object.selected'
  | 'camera.changed'
  | 'visual.stateChanged'
  | 'player.error';

export interface ConfigEvent<TPayload = Record<string, unknown>> {
  eventId: EventId;
  type: ConfigEventType;
  payload: TPayload;
  context: ContractContext;
}

export interface SelectionIntentPayload {
  targetType: 'attribute' | 'component' | 'hotspot' | 'object';
  targetId: string;
  suggestedValueId?: string;
  semanticTags?: string[];
}

export type ErrorEvent = ConfigEvent<ContractError>;
